import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]
  static values = {
    open: Boolean
  }

  connect() {
    if (this.openValue) {
      this.show()
    }
  }

  continue() {
    this.close()
    this.dispatch("continued")
  }

  reset() {
    this.close()
    this.dispatch("reset")
  }

  show() {
    if (this.hasDialogTarget) {
      this.dialogTarget.showModal()
    }
  }

  close() {
    if (this.hasDialogTarget) {
      this.dialogTarget.close()
    }
  }
}
